/** @format */

import React from "react";
import Search from "./Search";
import Footer from "./Footer";
import "../Style/Dictionary.css";

const Dictionary = () => {
  return (
    <div className="Dictionary">
      <Search />
      <Footer />
    </div>
  );
};
export default Dictionary;
